import React from "react";
import { Flex, Input, SearchIcon } from "@fluentui/react-northstar";
import styled from "styled-components";
import { Container, ContainerFluid } from "../../../components/layouts";
import { DEVICE } from "../../../constants/responsive";
import {
    useQueryGetAllAgencies,
    useQueryGetAllManagers,
} from "../../../api/helpers/queries";
import { Dropdown } from "@fluentui/react-northstar";
import useSearchFilters from "../hooks/useSearchFilters";

const Searchbar = ({ onChange }) => {
    const { states, handlers } = useSearchFilters();
    const { format_data, default_selected_manager } = useQueryGetAllManagers();
    const { format_data: format_data_agencies, default_selected_agency } =
        useQueryGetAllAgencies();

    return (
        <ContainerFluid fill>
            <Container fill>
                <FlexStyle hAlign="center" fill gap="gap.large">
                    <Flex fill>
                        <InputStyle
                            icon={<SearchIcon />}
                            placeholder="Chercher par nom, métier ou équipe"
                            onChange={(e) => onChange(e.target.value)}
                            defaultValue={states.querySearchValue}
                            inverted
                            clearable
                        />
                    </Flex>
                    <Flex>
                        <Dropdown
                            items={format_data}
                            placeholder="Filtrer par manager"
                            checkable
                            multiple
                            getA11ySelectionMessage={{
                                onAdd: (item) => `${item} has been selected.`,
                            }}
                            value={default_selected_manager}
                            onChange={handlers.onChangeManager}
                            styles={{
                                width: "100%",
                            }}
                            inverted
                        />
                    </Flex>
                    <Flex>
                        <Dropdown
                            items={format_data_agencies}
                            placeholder="Filtrer par agence"
                            checkable
                            multiple
                            getA11ySelectionMessage={{
                                onAdd: (item) => `${item} has been selected.`,
                            }}
                            value={default_selected_agency}
                            onChange={handlers.onChangeAgency}
                            styles={{
                                width: "100%",
                            }}
                            inverted
                        />
                    </Flex>
                </FlexStyle>
            </Container>
        </ContainerFluid>
    );
};

export default Searchbar;

const InputStyle = styled(Input)`
    width: 100%;
    .ui-input__input {
        width: 100%;
    }
`;

const FlexStyle = styled(Flex)`
    padding: 21px 0px;
    @media ${DEVICE.mobileS} {
        padding-inline: 10px;
    }
    @media ${DEVICE.laptop} {
        padding-inline: 0px;
    }
`;
